export type ExtraSpecificationResources = {
  cpuCores?: number
  ramGB?: number
  diskGB?: number
}

const EXTRA_RESOURCE_FIELDS: (keyof ExtraSpecificationResources)[] = ['cpuCores', 'ramGB', 'diskGB']

export function getExtraSpecificationActionState(
  current: ExtraSpecificationResources,
  minimum: ExtraSpecificationResources,
) {
  const hasMinimumRequirement = EXTRA_RESOURCE_FIELDS.some((field) => (minimum[field] ?? 0) > 0)
  const hasManualAdjustment = EXTRA_RESOURCE_FIELDS.some(
    (field) => (current[field] ?? 0) > (minimum[field] ?? 0),
  )

  return {
    hasMinimumRequirement,
    hasManualAdjustment,
    showMinimumRequirementNotice: hasMinimumRequirement && !hasManualAdjustment,
    resetDisabled: hasMinimumRequirement && !hasManualAdjustment,
    discardDisabled: hasMinimumRequirement,
  }
}
